import register from '@kpsys/angularjs-register';
import { ModalDialogService } from './modal-dialog.service';

/**
 * @ngdoc module
 * @module portaro.modal-dialogs
 * @name portaro.modal-dialogs
 */
export default register('portaro.modal-dialogs')
    .service(ModalDialogService.serviceName, ModalDialogService)
    .name()